import boxShadows from "assets/theme/box-shadow.js";
import hexToRgb from "assets/theme/hex-to-rgb.js";
import themeColors from "assets/theme/colors.js";

const componentStyles = (theme) => ({
  bgDefault: {
    backgroundColor: themeColors.dark.main,
  },
  bgWhite: {
    backgroundColor: themeColors.white.main,
    zIndex: 999,
  },
  typographyH2: {
    fontSize: "2.1875rem",
    fontWeight: 600,
    lineHeight: 1.5,
    color: themeColors.white.main,
  },
  typographyH2Dark: {
    fontSize: "2.1875rem",
    fontWeight: 600,
    lineHeight: 1.5,
    color: themeColors.bsColors.MainBlue,
  },
  centerElements: {
    justifyContent: "center",
    textAlign: "center",
  },
  leftElements: {
    justifyContent: "center",
    textAlign: "left",
  },
  orderMd1: {
    [theme.breakpoints.up("md")]: {
      order: 1,
    },
  },
  orderMd2: {
    [theme.breakpoints.up("md")]: {
      order: 2,
    },
  },
  prMd5: {
    [theme.breakpoints.up("md")]: {
      paddingRight: "3rem",
    },
  },
  justifyContentCenter: {
    justifyContent: "center",
  },
  imgBox: {
    verticalAlign: "middle",
    borderStyle: "none",
    [theme.breakpoints.up("md")]: {
      paddingRight: "3rem",
    },
  },
  imgBoxHero: {
    verticalAlign: "middle",
    borderStyle: "none",
    [theme.breakpoints.up("md")]: {
      paddingRight: "3rem",
    },
    [theme.breakpoints.down("sm")]: {
      width: "2rem",
    },
  },
  listStyleNone: {
    listStyle: "none",
  },
  typographyH4: {
    marginBottom: "0",
    marginLeft: "1rem",
  },
  typographyH4White: {
    marginBottom: "0",
    marginLeft: "1rem",
    color: themeColors.white.main  },
  warningAnchor: {
    textDecoration: "none",
    "&:hover": {
      color: themeColors.warning.dark,
    },
  },
  infoAnchor: {
    textDecoration: "none",
    "&:hover": {
      color: themeColors.info.dark,
    },
  },
  textCenter: {
    textAlign: "center",
  },
  blurWrapper: {
    "&:hover $blurItem": {
      opacity: ".8",
      WebkitFilter: "blur(10px)",
      filter: "blur(10px)",
      transform: "scale(.95)",
      zIndex: 1,
    },
    "&:hover $blurHidden": {
      opacity: 1,
      top: "50%",
    },
  },
  blurItem: {
    transition: "1s cubic-bezier(.19,1,.22,1)",
    willChange: "transform",
    WebkitFilter: "blur(0)",
    filter: "blur(0)",
    opacity: 1,
    position: "relative",
    maxWidth: "100%",
    height: "360px",
    margin: "0 auto",
    zIndex: 1,
  },
  blurHidden: {
    color: themeColors.success.main,
    position: "absolute",
    top: "calc(50% + 7px)",
    left: "50%",
    transform: "translate(-50%,-50%)",
    opacity: 0,
    transition: "all .15s ease",
    zIndex: 100,
  },
  iconNi: {
    width: "5rem",
    height: "5rem",
    fontSize: "1.7em",
    color: themeColors.primary.main,
    position: "absolute",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
    background: "#fff",
    zIndex: 1,
    transform: "translate(-50%,-50%)",
    boxShadow: "0 0 2rem 0 rgb(136 152 170 / 15%)",
    transition: "all .2s cubic-bezier(.25,.65,.9,.75)",
    "&:first-child": {
      left: "50%",
      top: "50%",
      fontSize: "42px",
      color: themeColors.warning.main,
    },
    "&:nth-child(2)": {
      width: "3.75rem",
      height: "3.75rem",
      fontSize: "1.5em",
      left: "calc(50% + 7rem*1.7)",
      top: "50%",
    },
    "&:nth-child(3)": {
      width: "3.75rem",
      height: "3.75rem",
      fontSize: "1.5em",
      left: "calc(50% + 7rem)",
      top: "calc(50% + 7rem)",
    },
    "&:nth-child(4)": {
      width: "3.75rem",
      height: "3.75rem",
      fontSize: "1.5em",
      left: "calc(50% + 7rem)",
      top: "calc(50% - 7rem)",
    },
    "&:nth-child(5)": {
      left: "calc(50% + 7rem*4)",
      top: "50%",
    },
    "&:nth-child(6)": {
      left: "calc(50% + 7rem*2.7)",
      top: "calc(50% + 7rem*1.5)",
    },
    "&:nth-child(7)": {
      left: "calc(50% + 7rem*2.7)",
      top: "calc(50% - 7rem*1.5)",
    },
    "&:nth-child(8)": {
      width: "3.75rem",
      height: "3.75rem",
      fontSize: "1.5em",
      left: "calc(50% - 7rem*1.7)",
      top: "50%",
    },
    "&:nth-child(9)": {
      width: "3.75rem",
      height: "3.75rem",
      fontSize: "1.5em",
      left: "calc(50% - 7rem)",
      top: "calc(50% + 7rem)",
    },
    "&:nth-child(10)": {
      width: "3.75rem",
      height: "3.75rem",
      fontSize: "1.5em",
      left: "calc(50% - 7rem)",
      top: "calc(50% - 7rem)",
    },
    "&:nth-child(11)": {
      left: "calc(50% - 7rem*4)",
      top: "50%",
    },
    "&:nth-child(12)": {
      left: "calc(50% - 7rem*2.7)",
      top: "calc(50% + 7rem*1.5)",
    },
    "&:nth-child(13)": {
      left: "calc(50% - 7rem*2.7)",
      top: "calc(50% - 7rem*1.5)",
    },
  },
  buttonRoot: {
    color: themeColors.white.main,
    backgroundColor: themeColors.bsColors.LogoLightBlue,
    borderColor: themeColors.bsColors.LogoLightBlue,
    marginRight: "1rem",
    fontSize: theme.typography.h5.fontSize,
    "&:hover": {
      backgroundColor: themeColors.bsColors.MainBlue,
      borderColor: themeColors.bsColors.MainBlue,
      color: themeColors.white.main,
    },
  },
  buttonRootAlternative: {
    color: themeColors.white.main,
    backgroundColor: themeColors.bsColors.Orange,
    borderColor: themeColors.bsColors.Orange,
    marginRight: "1rem",
    fontSize: theme.typography.h5.fontSize,
    "&:hover": {
      backgroundColor: themeColors.bsColors.Yellow,
      borderColor: themeColors.bsColors.Yellow,
      color: themeColors.white.main,
    },
  },
  buttonRootAlternativeStroke: {
    color: themeColors.bsColors.Orange,
    backgroundColor: themeColors.white.main,
    borderColor: themeColors.bsColors.Orange,
    marginRight: "1rem",
    fontSize: theme.typography.h5.fontSize,
    "&:hover": {
      backgroundColor: themeColors.bsColors.Orange,
      borderColor: themeColors.bsColors.Orange,
      color: themeColors.white.main,
    },
  },
  buttonCTANormal: {
    backgroundColor: themeColors.bsColors.LogoLightBlue,
    borderColor: themeColors.bsColors.LogoLightBlue,
    color: themeColors.white.main,
    "&:hover": {
      backgroundColor: themeColors.bsColors.MainBlue,
      borderColor: themeColors.bsColors.LogoLightBlue,
      color: themeColors.white.main,
    },
  },
  buttonCTANormalStroke: {
    backgroundColor: themeColors.white.main,
    borderColor: themeColors.bsColors.LogoLightBlue,
    color: themeColors.bsColors.LogoLightBlue,
    "&:hover": {
      backgroundColor: themeColors.bsColors.LogoLightBlue,
      borderColor: themeColors.bsColors.LogoLightBlue,
      color: themeColors.white.main,
    },
  },
  typographyH4Display4: {
    fontSize: "1.6275rem",
    fontWeight: 600,
    lineHeight: 1.5,
    marginTop: "3rem",
    marginBottom: "3rem",
  },
  imageBadge: {
    maxWidth: "100%",
    height: "auto",
    verticalAlign: "middle",
    borderStyle: "none",
    transition: "all .15s ease",
    boxShadow: boxShadows.boxShadow,
  },
  cardContentRoot: {
    display: "flex",
    justifyContent: "center",
    paddingTop: "0",
    paddingBottom: "0",
  },
  cardActionsRoot: {
    border: "0!important",
    background: "inherit!important",
  },
  cardHeaderRoot: {
    border: "0!important",
    background: "inherit",
  },
  typographyH1Pricing: {
    fontSize: "2.1875rem",
    fontWeight: 600,
    lineHeight: 1.5,
    color: themeColors.dark.main,
    marginBottom: "0",
  },
  textWhite: {
    color: themeColors.white.main + "!important",
  },
  typographyH5Pricing: {
    textTransform: "uppercase",
    marginBottom: "0",
  },
  paddingLg0: {
    [theme.breakpoints.up("md")]: {
      padding: "0!important",
    },
  },
  middleCard: {
    paddingTop: "2rem",
    paddingBottom: "2rem",
    border: "1px solid rgba(" + hexToRgb(themeColors.black.main) + ", 0.1)",
    backgroundColor: themeColors.dark.main,
  },
  largeIcon: {
    width: 40,
    height: 40,
    color: themeColors.bsColors.Orange
  },
  largeIconGreen: {
    width: 40,
    height: 40,
    color: themeColors.bsColors.LogoLightBlue
  },
  mediumGreenIcon: {
    width: 20,
    height: 20,
    color: themeColors.bsColors.NumberGreen
  },
});

export default componentStyles;
